
import {serializable, alias, primitive} from 'serializr';

export class ProductDistribution { 

	@serializable
	id?: number;

	@serializable(alias('product_id', primitive()))
	productId?: number;

	@serializable(alias('processing_facility_total', primitive()))
	processingFacilityTotal?: number;

	@serializable(alias('total_unit', primitive()))
	totalUnit?: number;

	@serializable(alias('online_retail', primitive()))
	onlineRetail?: number;

	@serializable
	createdAt?: string;

	@serializable
	updatedAt?: string;

}